import script from "./dokumen.vue?vue&type=script&setup=true&lang=ts"
export * from "./dokumen.vue?vue&type=script&setup=true&lang=ts"

import "./dokumen.vue?vue&type=style&index=0&id=3f5136f8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f5136f8"]])

export default __exports__